export const uiRootUrl = '/nuoriso'
const loginUrlBase = '/auth/saml/login?RelayState='
const logoutUrlBase = '/auth/saml/logout?RelayState='

export function loginUrl() {
  return `${loginUrlBase}${encodeURIComponent(window.location.href)}`
}

export function logoutUrl() {
  return `${logoutUrlBase}${encodeURIComponent(window.location.href)}`
}

export function home() {
  window.location.href = uiRootUrl
}
